import React, { Component } from 'react';
import "./textOverImageThumb.css";
import { Link } from "react-router-dom";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    return (
      <div className={'text-over-image-thumb-container'}>
        <div className={'text-over-image-thumb-background-image background-image-fill'} style={{backgroundImage: `url(${ this.props.image })`}}></div>
        <img className={'full-width'} src={this.props.image} style={{opacity:0}} />
        {this.props.link &&
          <Link to={this.props.link}>
            <div className={'text-over-image-thumb-overlay'}>
              <p className="text-over-image-thumb-overlay-text full-width white centered-text">{this.props.text}</p>
            </div>
          </Link>
        }
        {this.props.hrefLink &&
          <a href={this.props.hrefLink}>
            <div className={'text-over-image-thumb-overlay'}>
              <p className="text-over-image-thumb-overlay-text full-width white centered-text">{this.props.text}</p>
            </div>
          </a>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/textOverImageThumb/index.js